/**
 * 页面组件的引入
 */
import { coverQuery } from "$common/utils/url/url";

export default {
  use: (Vue, Router, loadLanguageAsync) => {
    Vue.use(Router);
    const { routerPreFix } = require("$proDirname/prefix");
    //  设置 spa 的路由前缀
    const prefix =
      window?.ssrConfig?.routerConfig?.name ??
      `/${routerPreFix.superAppUserV1}/index`;
    const router = new Router({
      mode: "history",
      prefix,
      routes: [
        {
          path: `*`,
          redirect: `${prefix}/login`
        },
        // 登录页
        {
          name: "login",
          path: `${prefix}/login`,
          component: resolve => import("./login").then(resolve)
        },
        // 分享登录页
        {
          name: "treasure-login",
          path: `${prefix}/treasure-login`,
          component: resolve => import("./treasure-login").then(resolve)
        },
        // 验证码登录
        {
          name: "login-verification-code",
          path: `${prefix}/login-verification-code`,
          component: resolve =>
            import("./login-verification-code").then(resolve)
        },
        // 分享验证码登录
        {
          name: "treasureLogin-verification-code",
          path: `${prefix}/treasureLogin-verification-code`,
          component: resolve =>
            import("./treasureLogin-verification-code").then(resolve)
        },
        {
          name: "legal-policies",
          path: `${prefix}/legal-policies`,
          component: resolve => import("./legal-policies").then(resolve)
        },
        {
          name: "privacy-policy",
          path: `${prefix}/privacy-policy`,
          component: resolve => import("./privacy-policy").then(resolve)
        },
        {
          name: "logout-notice",
          path: `${prefix}/logout-notice`,
          component: resolve => import("./logout-notice").then(resolve)
        },
        {
          name: "help-center",
          path: `${prefix}/help-center`,
          component: resolve => import("./help-center").then(resolve)
        },
        {
          name: "help-center-v2",
          path: `${prefix}/help-center-v2`,
          component: resolve => import("./help-center-v2").then(resolve)
        },
        {
          name: "help-center-video",
          path: `${prefix}/help-center-video`,
          component: resolve => import("./help-center-video").then(resolve)
        },
        {
          name: "cart",
          path: `${prefix}/cart`,
          component: resolve => import("./cart").then(resolve)
        },
        {
          name: "confirm-order",
          path: `${prefix}/confirm-order`,
          component: resolve => import("./confirm-order").then(resolve)
        },
        {
          name: "address-list",
          path: `${prefix}/address-list`,
          component: resolve => import("./address-list").then(resolve)
        },
        {
          name: "add-address",
          path: `${prefix}/add-address`,
          component: resolve => import("./add-address").then(resolve)
        },
        {
          name: "select-address",
          path: `${prefix}/select-address`,
          component: resolve => import("./select-address").then(resolve)
        },
        {
          name: "order-list",
          path: `${prefix}/order-list`,
          component: resolve => import("./order-list").then(resolve)
        },
        {
          name: "order-detail",
          path: `${prefix}/order-detail`,
          component: resolve => import("./order-detail").then(resolve)
        },
        {
          name: "pay-result",
          path: `${prefix}/pay-result`,
          component: resolve => import("./pay-result").then(resolve)
        },
        {
          name: "receiver",
          path: `${prefix}/receiver`,
          component: () => import("./receiver")
        },
        {
          name: "order-remark",
          path: `${prefix}/order-remark`,
          component: () => import("./order-remark")
        },
        {
          name: "set-invitation-code",
          path: `${prefix}/set-invitation-code`,
          component: () => import("./set-invitation-code")
        },
        {
          name: "invitation-code",
          path: `${prefix}/invitation-code`,
          component: () => import("./invitation-code")
        },
        {
          name: "register",
          path: `${prefix}/register`,
          component: () => import("./register")
        },
        {
          // 通用邀请
          name: "general-invite",
          path: `${prefix}/general-invite`,
          component: () => import("./general-invite")
        },
        {
          // 通用邀请落地页
          name: "general-invite-landing",
          path: `${prefix}/general-invite-landing`,
          component: () => import("./general-invite-landing")
        },
        {
          // 五月邀请活动
          name: "may-invite",
          path: `${prefix}/may-invite`,
          component: () => import("./may-invite")
        },
        // {
        //   // 通用邀请落地页v2
        //   name: 'general-invite-landing-v2',
        //   path: `${prefix}/general-invite-landing-v2`,
        //   component: () => import('./general-invite-landing-v2')
        // },
        {
          // 邀请有礼
          name: "gift-after-invitation",
          path: `${prefix}/gift-after-invitation`,
          component: () => import("./gift-after-invitation")
        },
        {
          // 邀请有礼 - 邀请记录
          name: "invitation-record",
          path: `${prefix}/invitation-record`,
          component: () => import("./invitation-record")
        },
        {
          // 邀请有礼-分享页
          name: "invitation-share",
          path: `${prefix}/invitation-share`,
          component: () => import("./invitation-share")
        },
        {
          name: "invitation-help",
          path: `${prefix}/invitation-help`,
          component: () => import("./invitation-help")
        },
        {
          name: "select-coupon-v2",
          path: `${prefix}/select-coupon-v2`,
          component: () => import("./select-coupon-v2")
        },
        {
          name: "order-select-coupon",
          path: `${prefix}/order-select-coupon`,
          component: () => import("./order-select-coupon")
        },
        {
          name: "select-coupon",
          path: `${prefix}/select-coupon`,
          component: () => import("./select-coupon")
        },
        {
          name: "transfer-payment",
          path: `${prefix}/transfer-payment`,
          component: () => import("./transfer-payment")
        },
        {
          name: "apply-refund",
          path: `${prefix}/apply-refund`,
          component: () => import("./apply-refund")
        },
        {
          name: "apply-detail",
          path: `${prefix}/apply-detail`,
          component: () => import("./apply-detail")
        },
        {
          name: "promote-apply",
          path: `${prefix}/promote-apply`,
          component: () => import("./promote-apply")
        },
        {
          name: "transfer-help",
          path: `${prefix}/transfer-help`,
          component: () => import("./transfer-help")
        },
        {
          name: "transfer-payment",
          path: `${prefix}/transfer-payment`,
          component: () => import("./transfer-payment")
        },
        {
          name: "apply-refund",
          path: `${prefix}/apply-refund`,
          component: () => import("./apply-refund")
        },
        {
          name: "apply-detail",
          path: `${prefix}/apply-detail`,
          component: () => import("./apply-detail")
        },
        {
          name: "transfer-help",
          path: `${prefix}/transfer-help`,
          component: () => import("./transfer-help")
        },
        {
          // 推广员页面
          name: "promoter-page",
          path: `${prefix}/promoter-page`,
          component: () => import("./promoter-page")
        },
        {
          // 推广员邀请列表记录
          name: "promoter-invite-record",
          path: `${prefix}/promoter-invite-record`,
          component: () => import("./promoter-invite-record")
        },
        {
          // 推广员收入列表记录
          name: "promoter-income-record",
          path: `${prefix}/promoter-income-record`,
          component: () => import("./promoter-income-record")
        },
        {
          // 推广员落地页
          name: "promoter-landing-page",
          path: `${prefix}/promoter-landing-page`,
          component: () => import("./promoter-landing-page")
        },
        {
          // 消费排行榜
          name: "rank-consumption",
          path: `${prefix}/rank-consumption`,
          component: () => import("./rank-consumption")
        },
        {
          // 消费排行榜
          name: "rank-history",
          path: `${prefix}/rank-history`,
          component: () => import("./rank-consumption/rank-history")
        },
        {
          // 活动页
          name: "invite-events",
          path: `${prefix}/invite-events`,
          component: () => import("./invite-events")
        },
        {
          // 活动页-被邀请人的入口页面
          name: "immediately-transfer",
          path: `${prefix}/immediately-transfer`,
          component: () => import("./immediately-transfer")
        }
      ]
    });
    //  路由切换懒加载对应的国家化文案
    router.beforeEach((to, from, next) => {
      coverQuery(to);
      if (window.$vm?.$Statistics) {
        window.$vm?.$Statistics.onEvent("page", from.name, {
          url: window.location.href
        });
      }
      if (
        window.$vm?.$root?.backRouterName &&
        to.name !== window.$vm?.$root?.backRouterName
      ) {
        this.$router.go(-1);
      } else {
        if (window.$vm?.$root) {
          window.$vm.$root.backRouterName = "";
        }
        loadLanguageAsync({
          router: to.name
        })
          .then(() => next())
          .catch(() => next());
      }
    });
    return router;
  }
};
